<iss-form-field [showNecessity]="showNecessity">
  <iss-label>{{ label || 'Role' }}</iss-label>
  <tui-select
    [formControl]="control.control"
    [tuiTextfieldLabelOutside]="true"
    [tuiTextfieldCleaner]="clearable"
    [readOnly]="!!readonly"
    [valueContent]="valueContent"
  >
    Role
    <ng-template tuiDataList>
      <tui-data-list>
        <button
          *ngFor="let item of roles"
          tuiOption
          [value]="item"
        >
          {{ item | capitalize }}
        </button>
      </tui-data-list>
    </ng-template>
  </tui-select>
  <ng-template #valueContent let-value>
    {{ value | capitalize }}
  </ng-template>
</iss-form-field>
